// Regex explained: https://regexr.com/5c55v
const re = /([0-9]+|([A-Z][a-z]+)|[a-z]+|([A-Z]+)(?![a-z]))/g;

export const kebabCase = (str: string) =>
    (String(str ?? "").match(re) || []).map((x) => x.toLowerCase()).join("-");
